module.exports = __webpack_public_path__ + "static/media/NJ_State.28ca2b9b.png";